export enum StatusKind {
  New = 'new',
  Report = 'report',
  Alert = 'alert',
  Insight = 'insight',
  Recommend = 'recommend',
  Ai = 'ai',
  Other = 'other',
}
